import { useState } from 'react'
import { Node as NodeIcon, Link as LinkIcon } from 'genesis-suite/icons'
import { Autocomplete, Box, Grid, ListItem, TextField, Typography } from '@mui/material'

const PropertySelector = props => {
    const { id, elementOptions, propsByElementId, defaultElement, defaultProperties, onChange } = props
    const [element, setElement] = useState(defaultElement)
    const [properties, setProperties] = useState(defaultProperties)

    const propertyOptions = element ? propsByElementId[element.value] || [] : []

    return (
        <Grid container spacing={8} alignItems="center">
            <Grid item xs={6}>
                <Autocomplete
                    disableClearable
                    ChipProps={{ size: 'small' }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={params => <TextField placeholder="Select Node/Link..." {...params} />}
                    renderOption={(props, option) => (
                        <ListItem {...props} key={option.value}>
                            {option.type === 'node' && <NodeIcon fontSize="small" />}
                            {option.type === 'link' && <LinkIcon fontSize="small" />}
                            <Box ml={1} />
                            <Typography>{option.label}</Typography>
                        </ListItem>
                    )}
                    options={elementOptions}
                    value={element ?? ''}
                    onChange={(e, value) => {
                        onChange(value, id, 'element')
                        setProperties(null)
                        setElement(value)
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <Autocomplete
                    multiple
                    filterSelectedOptions
                    ChipProps={{ size: 'small' }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    getOptionLabel={option => option.label ?? ''}
                    renderInput={params => <TextField placeholder="Select Properties..." {...params} />}
                    options={propertyOptions}
                    value={properties ?? []}
                    onChange={(e, values) => {
                        onChange(values, id)
                        setProperties(values)
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default PropertySelector
